export default "__VITE_ASSET__DG5tHLlC__"